import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNausea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M13.7499 13.1252C13.7499 12.8752 13.6012 12.6489 13.3712 12.5508L8.99616 10.6758L8.50366 11.8245L11.538 13.1252L8.50366 14.4258L8.99616 15.5745L13.3712 13.6995C13.6012 13.6014 13.7499 13.3752 13.7499 13.1252Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M26.0037 10.6758L21.6287 12.5508C21.3987 12.6489 21.25 12.8752 21.25 13.1252C21.25 13.3752 21.3987 13.6014 21.6287 13.6995L26.0037 15.5745L26.4963 14.4258L23.4619 13.1252L26.4963 11.8245L26.0037 10.6758Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M17.5 0C7.85063 0 0 7.85063 0 17.5C0 27.1494 7.85063 35 17.5 35C27.1494 35 35 27.1494 35 17.5C35 7.85063 27.1494 0 17.5 0ZM17.5 33.75C8.54 33.75 1.25 26.46 1.25 17.5C1.25 8.54 8.54 1.25 17.5 1.25C26.46 1.25 33.75 8.54 33.75 17.5C33.75 26.46 26.46 33.75 17.5 33.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M20.3125 21.7188C19.1062 21.7188 18.125 22.7 18.125 23.9062C18.125 24.2506 17.8444 24.5312 17.5 24.5312C17.1556 24.5312 16.875 24.2506 16.875 23.9062C16.875 22.7 15.8937 21.7188 14.6875 21.7188C13.4813 21.7188 12.5 22.7 12.5 23.9062V24.2188H13.75V23.9062C13.75 23.3894 14.1706 22.9688 14.6875 22.9688C15.2044 22.9688 15.625 23.3894 15.625 23.9062C15.625 24.94 16.4662 25.7812 17.5 25.7812C18.5338 25.7812 19.375 24.94 19.375 23.9062C19.375 23.3894 19.7956 22.9688 20.3125 22.9688C20.8294 22.9688 21.25 23.3894 21.25 23.9062V24.2188H22.5V23.9062C22.5 22.7 21.5188 21.7188 20.3125 21.7188Z"
		})
	]
});
export default SvgNausea;
